<template>
  <div>
    <div class="jst_main" v-show=" this.StatusId   < 4 ">
      <div class="jst_head">
        <div class="jst_content">
          <div style="display: flex;justify-content: space-between;">
            <div style="margin-bottom: 0.9375rem;">
              <span style="color: #333;font-size: 0.875rem;">选择行业 :</span>
              <el-select v-model="valueHY" placeholder="请选择" @change="chooseHY">
                <el-option v-for="item in optionsHY" :key="item.title" :label="item.title" :value="item.title">
                </el-option>
              </el-select>
            </div>
          </div>

          <!-- 交通运输-旅客运输 -->
          <div class="jst_layout" v-show="this.valueHY == '交通运输-旅客运输' || this.valueHY == '交通运输-普通货物运输' ||this.valueHY == '交通运输-危货企业' ||this.valueHY == '交通运输-邮政快递' ||
          this.valueHY == '交通运输-汽车驾驶培训'||this.valueHY == '交通运输-汽车客运'
          ">
            <el-row :gutter="20">
              <el-col :span="8">
                <el-card shadow="hover" class="jgb20">
                  <div class="dcard1">
                    <div class="dcard2">
                      <div class="dcard3">
                        <i class="el-icon-set-up" style="color: white;"></i>
                      </div>
                      <div style="display: grid;">
                        <div class="dcard4">车辆数量</div>
                        <div class="dcard4 colorStyle">{{this.echartsForm.car_count_fgc}}</div>
                      </div>
                    </div>
                  </div>
                </el-card>
              </el-col>
               <el-col :span="8">
                 <el-card shadow="hover" class="jgb20">
                   <div class="dcard1">
                     <div class="dcard2">
                       <div class="dcard3">
                         <i class="el-icon-set-up" style="color: white;"></i>
                       </div>
                       <div style="display: grid;">
                         <div class="dcard4">挂车数量</div>
                         <div class="dcard4 colorStyle">{{this.echartsForm.car_count_gc}}</div>
                       </div>
                     </div>
                   </div>
                 </el-card>
               </el-col>
              <el-col :span="8">
                <el-card shadow="hover" class="jgb20">
                  <div class="dcard1">
                    <div class="dcard2">
                      <div class="dcard3">
                        <i class="el-icon-connection" style="color: white;"></i>
                      </div>
                      <div style="display: grid;">
                        <div class="dcard4">安全工作例会数量</div>
                        <div class="dcard4 colorStyle">{{this.echartsForm.lihui}}</div>
                      </div>
                    </div>
                  </div>
                </el-card>
              </el-col>
              <el-col :span="8">
                <el-card shadow="hover" class="jgb20">
                  <div class="dcard1">
                    <div class="dcard2">
                      <div class="dcard3">
                        <i class="el-icon-connection" style="color: white;"></i>
                      </div>
                      <div style="display: grid;">
                        <div class="dcard4">安全人员数量</div>
                        <div class="dcard4 colorStyle">{{this.echartsForm.aq_user}}</div>
                      </div>
                    </div>
                  </div>
                </el-card>
              </el-col>
              <el-col :span="8">
                <el-card shadow="hover" class="jgb20">
                  <div class="dcard1">
                    <div class="dcard2">
                      <div class="dcard3">
                        <i class="el-icon-truck" style="color: white;"></i>
                      </div>
                      <div style="display: grid;">
                        <div class="dcard4">从业人员数量</div>
                        <div class="dcard4 colorStyle">{{this.echartsForm.cy_user}}</div>
                      </div>
                    </div>
                  </div>
                </el-card>
              </el-col>
              <el-col :span="8">
                <el-card shadow="hover" class="jgb20">
                  <div class="dcard1">
                    <div class="dcard2">
                      <div class="dcard3">
                        <i class="el-icon-postcard" style="color: white;"></i>
                      </div>
                      <div style="display: grid;">
                        <div class="dcard4">隐患数量</div>
                        <div class="dcard4 colorStyle">{{this.echartsForm.yh_count}}</div>
                      </div>
                    </div>
                  </div>
                </el-card>
              </el-col>

              <el-col :span="12">
                <el-card shadow="hover" style="height: 29.375rem">
                  <template #header>
                    <div class="clearfix">
                      <span>风险预警</span>
                    </div>
                  </template>
                  <el-row :span='24'>
                    <el-col :span='11' class="borderStyle" style="margin-right: 20px;">
                      <div class="fontStyleNum">{{this.echartsForm.wxy_count}}</div>
                      <div class="fontStyle">待排查危险源</div>
                    </el-col>
                    <el-col :span='11' class="borderStyle">
                      <div class="fontStyleNum">{{this.echartsForm.yh_count}}</div>
                      <div class="fontStyle">待整改隐患</div>
                    </el-col>
                  </el-row>
                  <el-row :span='24'>
                    <el-col :span='11' class="borderStyle" style="margin-right: 20px;">
                      <div class="fontStyleNum">{{this.echartsForm.cs_wxy_count}}</div>
                      <div class="fontStyle">危险源超期未排查</div>
                    </el-col>
                    <el-col :span='11' class="borderStyle">
                      <div class="fontStyleNum">{{this.echartsForm.cs_yh_count}}</div>
                      <div class="fontStyle">隐患超期未整改</div>
                    </el-col>
                  </el-row>
                  <!--     <el-row :span='24'>
                    <el-col el-col :span='11'>
                      <div id="linkFXYSL" style="width: 500px;height:180px;position: relative;top: -35px;left: -90px;">
                      </div>
                    </el-col>
                  </el-row> -->
                </el-card>
              </el-col>

              <el-col :span="12">
                <el-card shadow="hover" style="height: 29.375rem">
                  <template #header>
                    <div class="clearfix">
                      <span>资质证件提醒</span>
                    </div>
                  </template>
                  <el-row :span='24'>
                    <el-col :span='7' class="borderStyle" style="margin-right: 20px;cursor: pointer;" @click.native="ToCarTotal('nj_car')">
                      <div class="fontStyleNum">{{this.echartsForm.nj_car}}</div>
                      <div class="fontStyle">临近年检车辆</div>
                    </el-col>
                    <el-col :span='7' class="borderStyle" style="margin-right: 20px;cursor: pointer;" @click.native="ToCarTotal('wnj_car')">
                      <div class="fontStyleNum">{{this.echartsForm.wnj_car}}</div>
                      <div class="fontStyle">超期未年检车辆</div>
                    </el-col>
                    <el-col :span='7' class="borderStyle" style="cursor: pointer;" @click.native="ToCarTotal('bx_car')">
                      <div class="fontStyleNum">{{this.echartsForm.bx_car}}</div>
                      <div class="fontStyle">车辆保险临近到期</div>
                    </el-col>
                  </el-row>
                  <el-row :span='24'>
                    <!--  <el-col :span='7' class="borderStyle" style="margin-right: 20px;">
                      <div class="fontStyleNum">{{this.echartsForm.user_car}}</div>
                      <div class="fontStyle">人员保险临近到期</div>
                    </el-col> -->
                    <el-col :span='7' class="borderStyle" style="margin-right: 20px;cursor: pointer;" @click.native="ToCarTotal('jsz_gq_car')">
                      <div class="fontStyleNum">{{this.echartsForm.jsz_gq_car}}</div>
                      <div class="fontStyle">驾驶证已过期人数</div>
                    </el-col>
                    <el-col :span='7' class="borderStyle" style="margin-right: 20px;cursor: pointer;" @click.native="ToCarTotal('cyzg_gq_car')">
                      <div class="fontStyleNum">{{this.echartsForm.cyzg_gq_car}}</div>
                      <div class="fontStyle">驾驶员从业资格证超期人数</div>
                    </el-col>
                    <el-col :span='7' class="borderStyle" style="cursor: pointer;" @click.native="ToCarTotal('jsz_car')">
                      <div class="fontStyleNum">{{this.echartsForm.jsz_car}}</div>
                      <div class="fontStyle">驾驶证即将过期人数</div>
                    </el-col>

                  </el-row>
                  <el-row :span='24'>
                    <el-col :span='7' class="borderStyle" style="margin-right: 20px;cursor: pointer;" @click.native="ToCarTotal('cyzg_car')">
                      <div class="fontStyleNum">{{this.echartsForm.cyzg_car}}</div>
                      <div class="fontStyle">驾驶员从业资格证临近超期人数</div>
                    </el-col>
                    <el-col :span='7' class="borderStyle" style="margin-right: 20px;cursor: pointer;" @click.native="ToCarTotal('jsy_car')">
                      <div class="fontStyleNum">{{this.echartsForm.jsy_car}}</div>
                      <div class="fontStyle">驾驶员上岗证临近超期人数</div>
                    </el-col>
                    <!--  <el-col :span='7' class="borderStyle">
                      <div class="fontStyleNum">{{this.echartsForm.jsy_gq_car}}</div>
                      <div class="fontStyle">驾驶员上岗证超期人数</div>
                    </el-col> -->
                  </el-row>
                </el-card>
              </el-col>
            </el-row>
          </div>
          <!-- 汽配维修 -->
          <div class="jst_layout" v-show="this.valueHY == '交通运输-机动车维修'">
            <el-row :gutter="20">
              <el-col :span="8">
                <el-card shadow="hover" class="jgb20">
                  <div class="dcard1">
                    <div class="dcard2">
                      <div class="dcard3">
                        <i class="el-icon-set-up" style="color: white;"></i>
                      </div>
                      <div style="display: grid;">
                        <div class="dcard4">设备数量</div>
                        <div class="dcard4 colorStyle" style="color: #ff7946;">{{this.echartsForm.car_count}}</div>
                      </div>
                    </div>
                  </div>
                </el-card>
              </el-col>
              <el-col :span="8">
                <el-card shadow="hover" class="jgb20">
                  <div class="dcard1">
                    <div class="dcard2">
                      <div class="dcard3">
                        <i class="el-icon-connection" style="color: white;"></i>
                      </div>
                      <div style="display: grid;">
                        <div class="dcard4">安全人员数量</div>
                        <div class="dcard4 colorStyle" >{{this.echartsForm.aq_user}}</div>
                      </div>
                    </div>
                  </div>
                </el-card>
              </el-col>
              <el-col :span="8">
                <el-card shadow="hover" class="jgb20">
                  <div class="dcard1">
                    <div class="dcard2">
                      <div class="dcard3">
                        <i class="el-icon-truck" style="color: white;"></i>
                      </div>
                      <div style="display: grid;">
                        <div class="dcard4">从业人员数量</div>
                        <div class="dcard4 colorStyle">{{this.echartsForm.cy_user}}</div>
                      </div>
                    </div>
                  </div>
                </el-card>
              </el-col>
              <el-col :span="8">
                <el-card shadow="hover" class="jgb20">
                  <div class="dcard1">
                    <div class="dcard2">
                      <div class="dcard3">
                        <i class="el-icon-postcard" style="color: white;"></i>
                      </div>
                      <div style="display: grid;">
                        <div class="dcard4">隐患数量</div>
                        <div class="dcard4 colorStyle">{{this.echartsForm.yh_count}}</div>
                      </div>
                    </div>
                  </div>
                </el-card>
              </el-col>

              <el-col :span="8">
                <el-card shadow="hover" class="jgb20">
                  <div class="dcard1">
                    <div class="dcard2">
                      <div class="dcard3">
                        <i class="el-icon-connection" style="color: white;"></i>
                      </div>
                      <div style="display: grid;">
                        <div class="dcard4">安全工作例会数量</div>
                        <div class="dcard4 colorStyle">{{this.echartsForm.lihui}}</div>
                      </div>
                    </div>
                  </div>
                </el-card>
              </el-col>
              <el-col :span="12">
                <el-card shadow="hover" style="height: 29.375rem">
                  <template #header>
                    <div class="clearfix">
                      <span>风险预警</span>
                    </div>
                  </template>
                  <el-row :span='24'>
                    <el-col :span='11' class="borderStyle" style="margin-right: 20px;">
                      <div class="fontStyleNum">{{this.echartsForm.wxy_count}}</div>
                      <div class="fontStyle">待排查危险源</div>
                    </el-col>
                    <el-col :span='11' class="borderStyle">
                      <div class="fontStyleNum">{{this.echartsForm.yh_count}}</div>
                      <div class="fontStyle">待整改隐患</div>
                    </el-col>
                  </el-row>
                  <el-row :span='24'>
                    <el-col :span='11' class="borderStyle" style="margin-right: 20px;">
                      <div class="fontStyleNum">{{this.echartsForm.cs_wxy_count}}</div>
                      <div class="fontStyle">危险源超期未排查</div>
                    </el-col>
                    <el-col :span='11' class="borderStyle">
                      <div class="fontStyleNum">{{this.echartsForm.cs_yh_count}}</div>
                      <div class="fontStyle">隐患超期未整改</div>
                    </el-col>
                  </el-row>
                  <!--  <el-row :span='24'>
                    <el-col el-col :span='11'>
                      <div id="linkFXYSL" style="width: 500px;height:180px;position: relative;top: -35px;left: -90px;">
                      </div>
                    </el-col>
                  </el-row> -->
                </el-card>
              </el-col>

              <el-col :span="12">
                <el-card shadow="hover" style="height: 29.375rem">
                  <template #header>
                    <div class="clearfix">
                      <span>资质证件提醒</span>
                    </div>
                  </template>
                  <el-row :span='24'>
                    <el-col :span='7' class="borderStyleTwo" style="margin-right: 20px;">
                      <div class="fontStyleNum">{{this.echartsForm.nj_car}}</div>
                      <div class="fontStyle">设备到期时间</div>
                    </el-col>
                    <el-col :span='7' class="borderStyleTwo" style="margin-right: 20px;">
                      <div class="fontStyleNum">{{this.echartsForm.wnj_car}}</div>
                      <div class="fontStyle">设备超期时间</div>
                    </el-col>
                    <!-- <el-col :span='7' class="borderStyleTwo">
                      <div class="fontStyleNum">{{this.echartsForm.bx_car}}</div>
                      <div class="fontStyle">人员保险临近到期</div>
                    </el-col> -->
                  </el-row>
                </el-card>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>


    <div class="jst_main" v-show="this.StatusId == 4">
      <div class="jst_head">
        <div class="jst_content">
          <!-- 交通运输-旅客运输 -->
          <div class="jst_layout">
            <el-row :gutter="20">
            <el-col :span="8">
              <el-card shadow="hover" class="jgb20">
                <div class="dcard1">
                  <div class="dcard2">
                    <div class="dcard3">
                      <i class="el-icon-set-up" style="color: white;"></i>
                    </div>
                    <div style="display: grid;">
                      <div class="dcard4">车辆数量</div>
                      <div class="dcard4 colorStyle">{{this.echartsForm.car_count_fgc}}</div>
                    </div>
                  </div>
                </div>
              </el-card>
            </el-col>
             <el-col :span="8">
               <el-card shadow="hover" class="jgb20">
                 <div class="dcard1">
                   <div class="dcard2">
                     <div class="dcard3">
                       <i class="el-icon-set-up" style="color: white;"></i>
                     </div>
                     <div style="display: grid;">
                       <div class="dcard4">挂车数量</div>
                       <div class="dcard4 colorStyle">{{this.echartsForm.car_count_gc}}</div>
                     </div>
                   </div>
                 </div>
               </el-card>
             </el-col>
            <el-col :span="8">
              <el-card shadow="hover" class="jgb20">
                <div class="dcard1">
                  <div class="dcard2">
                    <div class="dcard3">
                      <i class="el-icon-connection" style="color: white;"></i>
                    </div>
                    <div style="display: grid;">
                      <div class="dcard4">安全工作例会数量</div>
                      <div class="dcard4 colorStyle">{{this.echartsForm.lihui}}</div>
                    </div>
                  </div>
                </div>
              </el-card>
            </el-col>
            <el-col :span="8">
              <el-card shadow="hover" class="jgb20">
                <div class="dcard1">
                  <div class="dcard2">
                    <div class="dcard3">
                      <i class="el-icon-connection" style="color: white;"></i>
                    </div>
                    <div style="display: grid;">
                      <div class="dcard4">安全人员数量</div>
                      <div class="dcard4 colorStyle">{{this.echartsForm.aq_user}}</div>
                    </div>
                  </div>
                </div>
              </el-card>
            </el-col>
            <el-col :span="8">
              <el-card shadow="hover" class="jgb20">
                <div class="dcard1">
                  <div class="dcard2">
                    <div class="dcard3">
                      <i class="el-icon-truck" style="color: white;"></i>
                    </div>
                    <div style="display: grid;">
                      <div class="dcard4">从业人员数量</div>
                      <div class="dcard4 colorStyle">{{this.echartsForm.cy_user}}</div>
                    </div>
                  </div>
                </div>
              </el-card>
            </el-col>
            <el-col :span="8">
              <el-card shadow="hover" class="jgb20">
                <div class="dcard1">
                  <div class="dcard2">
                    <div class="dcard3">
                      <i class="el-icon-postcard" style="color: white;"></i>
                    </div>
                    <div style="display: grid;">
                      <div class="dcard4">隐患数量</div>
                      <div class="dcard4 colorStyle">{{this.echartsForm.yh_count}}</div>
                    </div>
                  </div>
                </div>
              </el-card>
            </el-col>

              <el-col :span="12">
                <el-card shadow="hover" style="height: 29.375rem">
                  <template #header>
                    <div class="clearfix">
                      <span>风险预警</span>
                    </div>
                  </template>
                  <el-row :span='24'>
                    <el-col :span='11' class="borderStyle" style="margin-right: 20px;">
                      <div class="fontStyleNum">{{this.echartsForm.wxy_count}}</div>
                      <div class="fontStyle">待排查危险源</div>
                    </el-col>
                    <el-col :span='11' class="borderStyle">
                      <div class="fontStyleNum">{{this.echartsForm.yh_count}}</div>
                      <div class="fontStyle">待整改隐患</div>
                    </el-col>
                  </el-row>
                  <el-row :span='24'>
                    <el-col :span='11' class="borderStyle" style="margin-right: 20px;">
                      <div class="fontStyleNum">{{this.echartsForm.cs_wxy_count}}</div>
                      <div class="fontStyle">危险源超期未排查</div>
                    </el-col>
                    <el-col :span='11' class="borderStyle">
                      <div class="fontStyleNum">{{this.echartsForm.cs_yh_count}}</div>
                      <div class="fontStyle">隐患超期未整改</div>
                    </el-col>
                  </el-row>
                  <!--     <el-row :span='24'>
                    <el-col el-col :span='11'>
                      <div id="linkFXYSL" style="width: 500px;height:180px;position: relative;top: -35px;left: -90px;">
                      </div>
                    </el-col>
                  </el-row> -->
                </el-card>
              </el-col>

              <el-col :span="12">
                <el-card shadow="hover" style="height: 29.375rem">
                  <template #header>
                    <div class="clearfix">
                      <span>资质证件提醒</span>

                    </div>
                  </template>
                  <el-row :span='24'>
                    <el-col :span='7' class="borderStyle" style="margin-right: 20px;cursor: pointer;" @click.native="ToCarTotal('nj_car')">
                      <div class="fontStyleNum">{{this.echartsForm.nj_car}}</div>
                      <div class="fontStyle">临近年检车辆</div>
                    </el-col>
                    <el-col :span='7' class="borderStyle" style="margin-right: 20px;cursor: pointer;" @click.native="ToCarTotal('wnj_car')">
                      <div class="fontStyleNum">{{this.echartsForm.wnj_car}}</div>
                      <div class="fontStyle">超期未年检车辆</div>
                    </el-col>
                    <el-col :span='7' class="borderStyle" style="cursor: pointer;" @click.native="ToCarTotal('bx_car')">
                      <div class="fontStyleNum">{{this.echartsForm.bx_car}}</div>
                      <div class="fontStyle">车辆保险临近到期</div>
                    </el-col>
                  </el-row>
                  <el-row :span='24'>
                    <!--  <el-col :span='7' class="borderStyle" style="margin-right: 20px;">
                      <div class="fontStyleNum">{{this.echartsForm.user_car}}</div>
                      <div class="fontStyle">人员保险临近到期</div>
                    </el-col> -->
                    <el-col :span='7' class="borderStyle" style="margin-right: 20px;cursor: pointer;" @click.native="ToCarTotal('jsz_gq_car')">
                      <div class="fontStyleNum">{{this.echartsForm.jsz_gq_car}}</div>
                      <div class="fontStyle">驾驶证已过期人数</div>
                    </el-col>
                    <el-col :span='7' class="borderStyle" style="margin-right: 20px;cursor: pointer;" @click.native="ToCarTotal('cyzg_gq_car')">
                      <div class="fontStyleNum">{{this.echartsForm.cyzg_gq_car}}</div>
                      <div class="fontStyle">驾驶员从业资格证超期人数</div>
                    </el-col>
                    <el-col :span='7' class="borderStyle" style="cursor: pointer;" @click.native="ToCarTotal('jsz_car')">
                      <div class="fontStyleNum">{{this.echartsForm.jsz_car}}</div>
                      <div class="fontStyle">驾驶证即将过期人数</div>
                    </el-col>

                  </el-row>
                  <el-row :span='24'>
                    <el-col :span='7' class="borderStyle" style="margin-right: 20px;cursor: pointer;" @click.native="ToCarTotal('cyzg_car')">
                      <div class="fontStyleNum">{{this.echartsForm.cyzg_car}}</div>
                      <div class="fontStyle">驾驶员从业资格证临近超期人数</div>
                    </el-col>
                    <el-col :span='7' class="borderStyle" style="margin-right: 20px;cursor: pointer;" @click.native="ToCarTotal('jsy_car')">
                      <div class="fontStyleNum">{{this.echartsForm.jsy_car}}</div>
                      <div class="fontStyle">驾驶员上岗证临近超期人数</div>
                    </el-col>
                    <!--   <el-col :span='7' class="borderStyle">
                      <div class="fontStyleNum">{{this.echartsForm.jsy_gq_car}}</div>
                      <div class="fontStyle">驾驶员上岗证超期人数</div>
                    </el-col> -->
                  </el-row>
                </el-card>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>

    <el-dialog :title="titleName" :visible.sync="showModal" @close="closeModal">
      <div style="background-color: white; padding: 20px 0;">
        <div style="padding: 0 1.25rem;">
          <el-tabs v-model="activeNameTZ" @tab-click="handleClick">
            <el-tab-pane label="整改任务" name="first">
              <el-table :data="arrayListZG" @row-click="ToZG" style="width: 100%;">
                <el-table-column property="tc_title" label="标题"></el-table-column>
                <el-table-column property="tc_wc_date" label="时间"></el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="下发" name="second">
              <el-table :data="arrayList" @row-click="ToTZ" style="width: 100%;">
                <el-table-column property="no_title" label="标题"></el-table-column>
                <el-table-column property="yj_up_date" label="时间"></el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import * as echarts from 'echarts'
  export default {
    data() {
      return {
        isExpanded: true, // 默认展开
        echartsForm: {},
        activeName: '0',
        optionsHY: [],
        valueHY: '',
        StatusId: null,
        showModal: false,
        titleName: '消息弹窗',
        activeNameTZ: 'first',
        arrayList: [],
        arrayListZG: [],
    }
  },
  mounted() {
      this.getGG()
      if (this.arrayList.length <= 0 && this.arrayListZG.length <= 0) {
        this.showModal = false
      } else {
        if (!localStorage.getItem('visited')) {
          this.showModal = true
          localStorage.setItem('visited', 'true')
        }
      }

    },
    // mounted() {
    //   this.timer = setInterval(() => {
    //     this.openDialog()
    //   }, 5 * 60 * 1000) // 5分钟
    // },
    // beforeDestroy() {
    //   clearInterval(this.timer)
    // },
    created() {
      this.StatusId = localStorage.getItem('DeptStatus'),
        this.getListHY()
      this.getList()


    },
    methods: {
      getGG() {
        var that = this
        var data = {
          'bm_status': localStorage.getItem('DeptStatus'),
          'bm_id': localStorage.getItem('Deptid'),
        }
        this.$axios({
          method: 'post',
          url: '/apiadmin/Home/index_xf',
          headers: {
            'Authorization': 'ZhiHuiWanLian1.0'
          },
          data: data,
        }).then(function(response) {
          that.arrayList = response.data.data
        })
        this.$axios({
          method: 'post',
          url: '/apiadmin/Home/index_zg',
          headers: {
            'Authorization': 'ZhiHuiWanLian1.0'
          },
          data: data,
        }).then(function(response) {
          that.arrayListZG = response.data.data
        })

      },
      closeModal() {
        this.showModal = false
      },
      getListHY() {
        var that = this
        var data = {
          'bm_status': localStorage.getItem('DeptStatus'),
          'bm_id': localStorage.getItem('Deptid'),
        }
        this.$axios({
          method: 'post',
          url: '/apiadmin/Secure_base/departmentPermission',
          headers: {
            'Authorization': 'ZhiHuiWanLian1.0'
          },
          data: data,
        }).then(function(response) {
          if (response.data.length == 0) {
            console.log()
          } else {
            that.optionsHY = response.data
            that.valueHY = response.data[0].title
          }

        })
      },
      getList() {
        var data = {
          'bm_status': localStorage.getItem('DeptStatus'),
          'bm_id': localStorage.getItem('Deptid'),
          'hy_id': localStorage.getItem('hangye')
        }
        var that = this
        this.$axios({
          method: 'post',
          url: '/apiadmin/Dual_Control/index',
          headers: {
            'Authorization': 'ZhiHuiWanLian1.0'
          },
          data: data,
        }).then(function(response) {
          that.echartsForm = response.data
        })
      },
      handleClick(tab, event) {
        this.activeName = tab.index
        console.log(this.activeName);
        // this.getList()
      },
      // 选择行业
      chooseHY(value) {
        this.valueHY = value
        var selectedItem = this.optionsHY.find(item => item.title === value);
        var a = selectedItem.id
        var data = {
          'bm_status': localStorage.getItem('DeptStatus'),
          'bm_id': localStorage.getItem('Deptid'),
          'hy_id': a
        }
        var that = this
        this.$axios({
          method: 'post',
          url: '/apiadmin/Dual_Control/index',
          headers: {
            'Authorization': 'ZhiHuiWanLian1.0'
          },
          data: data,
        }).then(function(response) {
          that.echartsForm = response.data
        })
      },
      handleClick(tab, event) {
        console.log(tab, event);
        if (tab.index == '0') {
          var that = this
          var data = {
            'bm_status': localStorage.getItem('DeptStatus'),
            'bm_id': localStorage.getItem('Deptid'),
          }
          this.$axios({
            method: 'post',
            url: '/apiadmin/Home/index_xf',
            headers: {
              'Authorization': 'ZhiHuiWanLian1.0'
            },
            data: data,
          }).then(function(response) {
            that.arrayList = response.data.data
          })
        } else if (tab.index == '1') {
          var that = this
          var data = {
            'bm_status': localStorage.getItem('DeptStatus'),
            'bm_id': localStorage.getItem('Deptid'),
          }
          this.$axios({
            method: 'post',
            url: '/apiadmin/Home/index_zg',
            headers: {
              'Authorization': 'ZhiHuiWanLian1.0'
            },
            data: data,
          }).then(function(response) {
            that.arrayListZG = response.data.data
          })
        }
      },
      // 通知跳转
      ToTZ() {
        this.$router.push('/NoticeDowmEnter');
      },
      // 整改跳转
      ToZG() {
        this.$router.push('/downBack');
      },
      // 资质证件提醒跳转（根据点击的统计字段类型传值）
      ToCarTotal(type) {
        console.log('当前 this:', this);
          console.log('当前 $router:', this.$router);
          console.log('准备跳转，type:', type);
        this.$router.push({
          path: '/CarTotal',
          query: {
            type: type
          }
        });
      },
    }
  }
</script>

<style scoped>
  .jst_layout {
    float: left;
    color: #000;
  }

  .el-row {
    margin-bottom: 10px;
  }

  .my-label {
    background: #e1f3d8;
  }

  .my-content {
    background: #fde2e2;
  }

  .grid-content {
    display: flex;
    align-items: center;
    height: 100px;
  }

  .grid-cont-right {
    flex: 1;
    text-align: center;
    font-size: 14px;
    color: #999;
  }

  .grid-num {
    font-size: 30px;
    font-weight: bold;
  }

  .grid-con-icon {
    font-size: 50px;
    width: 100px;
    height: 100px;
    text-align: center;
    line-height: 100px;
    color: #fff;
  }

  .grid-con-1 .grid-con-icon {
    background: rgb(45, 140, 240);
  }

  .grid-con-1 .grid-num {
    color: rgb(45, 140, 240);
  }

  .grid-con-2 .grid-con-icon {
    background: rgb(100, 213, 114);
  }

  .grid-con-2 .grid-num {
    color: rgb(45, 140, 240);
  }

  .grid-con-3 .grid-con-icon {
    background: rgb(242, 94, 67);
  }

  .grid-con-3 .grid-num {
    color: rgb(242, 94, 67);
  }

  .user-info {
    display: flex;
    align-items: center;
    padding-bottom: 20px;
    border-bottom: 2px solid #ccc;
    margin-bottom: 20px;
  }

  .user-avator {
    width: 120px;
    height: 120px;
    border-radius: 50%;
  }

  .user-info-cont {
    padding-left: 50px;
    flex: 1;
    font-size: 14px;
    color: #999;
  }

  .user-info-cont div:first-child {
    font-size: 30px;
    color: #222;
  }

  .user-info-list {
    font-size: 14px;
    color: #999;
    line-height: 25px;
  }

  .user-info-list span {
    margin-left: 70px;
  }

  .mgb20 {
    margin-bottom: 20px;
  }

  .jgb20 {
    height: 5rem;
    margin-bottom: 10px;
  }

  .todo-item {
    font-size: 14px;
  }

  .todo-item-del {
    text-decoration: line-through;
    color: #999;
  }

  .schart {
    width: 100%;
    height: 300px;
  }

  .dcard1 {
    width: 100%;
    height: 100%;
  }

  .dcard2 {
    float: left;
  }

  .dcard3 {
    float: left;
    width: 3.75rem;
    height: 3.75rem;
    line-height: 3.75rem;
    background-color: #ff7946;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    text-align: center;
    margin-top: -0.625rem;
    border-radius: 0.375rem;
  }

  .dcard4 {
    float: left;
    font-size: 0.85rem;
    font-weight: 700;
    text-transform: capitalize;
    margin-left: 0.625rem;
    margin-top: -1rem;
  }

  .dcard5 {
    clear: left;
    font-size: 18px;
    font-weight: normal;
    line-height: 1.67;
    color: #121f3e;
    margin-top: 5px;
    float: left;
  }

  .dcard6 {
    font-size: 12px;
    font-weight: normal;
    color: #919bb1;
    float: left;
    clear: left;
    margin-top: -7px;
  }

  .el-card__header {
    padding: 10px 20px;
  }

  .el-tab {
    width: 100%;
    float: left;
    margin-top: -15px;
  }

  .colorStyle {
    color: #ff7946;
    margin-top: -12px;
    font-size: 1rem;
  }

  .borderStyle {
    border-radius: 4px;
    border: 1px solid #EBEEF5;
    background-color: #F3F1EF;
    overflow: hidden;
    color: #303133;
    -webkit-transition: .3s;
    transition: .3s;
    height: 80px;
    text-align: center;
  }

  .borderStyle:hover {
    background-color: #ff7946;
    cursor: pointer;
    color: white;
  }

  .borderStyleTwo {
    border-radius: 4px;
    border: 1px solid #EBEEF5;
    background-color: #F3F1EF;
    overflow: hidden;
    color: #303133;
    -webkit-transition: .3s;
    transition: .3s;
    height: 80px;
    text-align: center;
  }

  .borderStyleTwo:hover {
    background-color: #ff7946;
    cursor: pointer;
    color: white;
  }

  .fontStyleNum {
  color: #121f3e;
  font-size: 15px;
  font-weight: 700;
  }
/*  .fontStyleNum:hover {
    color: #fff;
    font-size: 15px;
    font-weight: 700;
  } */

  .fontStyle {
    font-size: 0.75rem;
    margin-top: -10px;
  }

  .clearfix {
    font-weight: bolder;
  }

  .ConStyle {
    display: flex;
    justify-content: space-between;
    line-height: 40px;
    border-bottom: 1px solid #f0f0f0;
    font-size: 0.9375rem;
  }

  .ConStyle :hover {
    cursor: pointer;
    color: #ff6110;
  }

  /* 弹窗整体样式 */
  .expire-reminder-dialog {
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  /* 头部操作按钮 */
  .header-actions {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 10px;
    gap: 10px;
  }

  .header-actions .el-button {
    font-size: 12px;
    padding: 4px 8px;
    color: #999;
    border: none;
    background: transparent;
    cursor: pointer;
  }

  .header-actions .el-button:hover {
    color: #666;
  }

  /* 内容容器 */
  .content-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
  }

  /* 卡片样式 */
  .card {
    padding: 12px;
    background: #f9f9f9;
    border: 1px solid #e6e6e6;
    border-radius: 6px;
    text-align: center;
    transition: all 0.2s;
  }

  .card:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  .card .label {
    font-size: 12px;
    color: #666;
    line-height: 1.2;
  }

  .card .value {
    font-size: 16px;
    font-weight: bold;
    margin: 4px 0;
    color: #f56c6c;
    /* 红色高亮 */
  }

  .card .desc {
    font-size: 10px;
    color: #999;
  }
</style>



// WEBPACK FOOTER //
// src/views/components/home.vue